// actions/joke/joke.js

export function jokeHasErrored(bool) {
  return {
    type: 'JOKE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function jokeIsLoading(bool) {
  return {
    type: 'JOKE_IS_LOADING',
    isLoading: bool
  };
}

export function jokeFetchDataSuccess(data) {
  return {
    type: 'JOKE_FETCH_DATA_SUCCESS',
    data
  };
}

export function jokeFetchData(reset) {
  return (dispatch) => {
    if (reset) {
      dispatch(jokeFetchDataSuccess({}));
      dispatch(jokeHasErrored(false));
      dispatch(jokeIsLoading(false));
    }
    else {
      dispatch(jokeIsLoading(true));
      dispatch(jokeHasErrored(false));
      fetch('https://icanhazdadjoke.com', {
        method: 'get',
        headers: new Headers({'Accept': 'application/json'})
      }).then(promise => {
          if (!promise.ok) {
            throw Error(promise.statusText);
          }
          
          promise.json()
            .then(result => {
              dispatch(jokeFetchDataSuccess(result));
              dispatch(jokeHasErrored(false));
              dispatch(jokeIsLoading(false));
            })
            .catch((ex) => {
              console.log(ex);
              dispatch(jokeHasErrored(true));
              dispatch(jokeIsLoading(false));
            });
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(jokeHasErrored(true));
        dispatch(jokeIsLoading(false));
      });
    }
  };
}